import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

export default function ChipNew({ active }: { active: boolean }) {
    return (
        <Root label="New!"
            variant="filled"
            color={ active ? 'secondary' :  undefined } />
    );
}

const Root = styled(Chip)(({ theme }) => ({
    fontSize: '.5rem',
    height: 'auto',
    
    marginTop: theme.spacing(-4),

    '& .MuiChip-label': {
        padding: theme.spacing(0.5, 1)
    }
}));
